<div class="coaching-monthly-targets" *ngIf="targets">
  <div class="row" style="margin-bottom:8px;">
    <div class="col-sm-12" style="display:flex;flex-wrap:wrap;gap:8px;align-items:center;">
      <button type="button" class="btn btn-xs" (click)="year = year - 1" title="Previous year">&lsaquo;</button>
      <select class="form-control" style="width:auto;display:inline-block;" name="coachingTargetYear" [(ngModel)]="year">
        <option *ngFor="let y of years" [ngValue]="y">{{y}}</option>
      </select>
      <button type="button" class="btn btn-xs" (click)="year = year + 1" title="Next year">&rsaquo;</button>
      <span class="small text-muted">{{'coachingTargets.yearTotal' | translate}}: <b>{{yearTotal()}}</b></span>
    </div>
  </div>
  <div class="row">
    <div class="col-xs-4 col-sm-2" *ngFor="let m of months" style="margin-bottom:6px;">
      <label class="small" style="margin-bottom:2px;">{{monthNames[m - 1]}} {{year}}</label>
      <input type="number" min="0" class="form-control input-sm" [name]="'coachingTarget_' + year + '_' + m"
             [ngModel]="valueOf(m)" (ngModelChange)="setValue(m, $event)" placeholder="—" />
    </div>
  </div>
  <div class="row" style="margin-top:4px;">
    <div class="col-sm-12" style="display:flex;flex-wrap:wrap;gap:8px;align-items:center;">
      <input type="number" min="0" class="form-control input-sm" style="width:90px;" name="coachingTargetFill" [(ngModel)]="fillValue" />
      <button type="button" class="btn btn-xs" (click)="fillAll()">{{'coachingTargets.fillAll' | translate}} {{year}}</button>
      <button type="button" class="btn btn-xs" (click)="copyPreviousYear()">{{'coachingTargets.copyPreviousYear' | translate}} ({{year - 1}})</button>
      <button type="button" class="btn btn-xs" (click)="clearYear()">{{'coachingTargets.clearYear' | translate}} {{year}}</button>
    </div>
  </div>
  <span class="help-block" *ngIf="hint">{{hint}}</span>
</div>
